<template>
<!--  <el-select-->
<!--    size="mini"-->
<!--    v-model="default_checked_keys"-->
<!--    multiple-->
<!--    filterable-->
<!--    placeholder="选择下级"-->
<!--    :collapse-tags="true" style="width: 400px;" @change="onChange">-->
<!--    <el-option-->
<!--      v-for="item in mater_list"-->
<!--      :key="item.id"-->
<!--      :label="item.meter_name"-->
<!--      :value="item.id">-->
<!--    </el-option>-->
<!--  </el-select>-->
  <div style="width: 400px;max-height: 100px;overflow-y: scroll;">
    <div v-if="mater_list.length===0">请选择</div>
    <div v-for="item in mater_list">{{item.meter_name}}</div>
  </div>
</template>

<script>
import MeterHttp from "../../../common/MeterHttp";

export default {
  name: "SelectMeterComponent",
  props:{
    project_id: {type:Number|String,default:()=>0},
    checked_keys:{type:String||Number,default:()=>''},
  },
  data(){
    return{
      default_checked_keys:"",
      ids:[],
      options: [],
      loading: false,
      mater_list:[]
    }
  },
  mounted() {
    this.getKeyValue();
    this.reSelect();
  },
  methods:{
    reSelect(){
      if(this.checked_keys){
        let checked_keys=(this.checked_keys+"").split(',').map(id=>id*1);
        if(checked_keys.length){
          this.default_checked_keys=checked_keys
        }
      }
    },
    getKeyValue(){
      const that=this;
      MeterHttp.get("Meter/getKeyValue?user_type="+(that.$route.query.type||0), {ids: that.checked_keys, project_id: that.project_id}, ret => {
        if (ret.code) {
          that.mater_list=ret.data
        }
      })
    },
    onChange(){
      this.$emit('onChange',this.default_checked_keys)
    }
  },
  watch:{
    checked_keys(n,o){
      this.getKeyValue()
      this.reSelect()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/SelectMeterComponent.vue